import {text_mod_37, } from "../text/Text.js";
export const module37 = {
  title:
    "§37. Велика буква в кличках тварин​​",
  questions: [
    {
      id: 1,
      onlyText: true,
      text: text_mod_37, },
    ]
  }
